import React, {Component} from 'react';
import { ScrollView, View, StyleSheet, FlatList, ActivityIndicator, Dimensions} from 'react-native'
import { connect } from 'react-redux';
import { getCurrentAffairsListForPagination, dispatchClearGetCurrentAffairsListForPagination } from './../../store/action';
// import OfflineHandler from './../OfflineHandler';
// import BackHandlerAndroid from "./../AndroidBackHandler"
import CurrentAffairs from './../Home/CurrentAffairs';
import Header from './../../components/Header/index';
import { Styles } from '../../components/UI-Components';
const { width, height } = Dimensions.get("window");


class ListOfCurrentAffairs extends Component{
    state = {
        listOfCurrentAffairs:[]
    }
    componentDidMount(){
        
        this.props.getCurrentAffairsListForPagination({after: 0, before: 0})

    }

    componentDidUpdate(prevProps){
        if(prevProps.currentAffairs !== this.props.currentAffairs){
            if(this.props.currentAffairs){
                this.setState({
                    listOfCurrentAffairs:  [...this.state.listOfCurrentAffairs, ...this.props.currentAffairs]
                }, () => {
                    const lastIndex = this.state.listOfCurrentAffairs.length;
                    console.log(lastIndex);
                    const lastItem = this.state.listOfCurrentAffairs[lastIndex - 1]
                   
                    this.setState({
                        lastItem: lastItem && lastItem.id
                    }, () => console.log(this.state.lastItem))
                })
            }
        }
    }

    onEndReached = () => {
        console.log(this.state.lastItem)
        if(this.state.listOfCurrentAffairs && this.state.listOfCurrentAffairs.length > 10)
        this.props.getCurrentAffairsListForPagination({after: 0, before: this.state.lastItem});
    }

    render(){
      
        const { listOfCurrentAffairs } = this.state;
      
        return(
            <>
            <Header 
                title="Current Affairs"
                headerRight
                headerRightClick={() => this.props.history.push('/Home')}
                headerLeftClick={() => this.props.history.goBack()}
                // backButton={true}
                
            />
        
            
            <div className={`${this.props.loading ? "main-component" : 'full-height'} `}>
            {
                   this.props.loading && (listOfCurrentAffairs && listOfCurrentAffairs.length === 0) && 
                   <View style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                       <ActivityIndicator/>
                   </View>
               }

            <View
            style={styles.mainWrapper}
            >
            <View style={{   
                flex: 1,
                flexDirection: 'column',
                flexWrap: 'noWrap',
                }}
                >
                { listOfCurrentAffairs && listOfCurrentAffairs.length > 0 && listOfCurrentAffairs.map((item, index)  => {
                    return(
                        <CurrentAffairs  
                        currentAffairs={item} 
                        adsTrue={false}
                        fromList={true}
                    
                        />
                    )
                })
                    //       <FlatList
                    //         data={listOfCurrentAffairs}
                    //         style={{flexDirection: 'row'}}
                    //         renderItem={({ item }) => {
                               
                       
                    //         return   <CurrentAffairs  
                    //                 currentAffairs={item} 
                    //                 adsTrue={false}
                    //                 fromList={true}
                    
                    //             />
                    //      }}
                    //      keyExtractor={item => item.id}
                    //      onEndReached={this.onEndReached}
                    //      onEndReachedThreshold={0.5}
                         
                    //    />
                    
                   
                }
            </View>
            </View>
            </div>
            </>
        )
    }
}
const mapStatesToProps = state => {
    console.log(state);
    const currentAffairs = state.currentAffairsWithPagination && state.currentAffairsWithPagination.response && state.currentAffairsWithPagination.response.current_affairs 
    const loading = state.currentAffairsWithPagination && state.currentAffairsWithPagination.loading;
    const error = state.currentAffairsWithPagination && state.currentAffairsWithPagination.error               

    return {
        currentAffairs,
        loading,
        error
    }
}
export default connect(mapStatesToProps, {
    getCurrentAffairsListForPagination, dispatchClearGetCurrentAffairsListForPagination
})(ListOfCurrentAffairs)

const styles = StyleSheet.create({
    mainWrapper: {
        marginBottom: 10,
        marginTop: 10,
        backgroundColor: Styles.fiveMantraBgColor,
     
    }
});